<template>
  <div class="c-table" ref="monitorlogtable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table class="common-el-table-styles" :data="data" :height="height" v-loading="loading" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'bizType'">{{ scope.row[col.key] | bizType }}</span>
          <span v-else-if="col.key === 'ruleId'">
            <template v-if="scope.row[col.key]">
              <el-button type="text" v-if="scope.row.ruleType === 1" @click="showClick(scope.row)">{{ scope.row[col.key] }}</el-button>
              <el-button type="text" v-if="scope.row.ruleType === 4" @click="showConsumeClick(scope.row)">{{
                scope.row[col.key]
              }}</el-button>
            </template>
            <span v-else>-</span>
          </span>
          <span v-else-if="col.key === 'opType'">{{ scope.row[col.key] | opType }}</span>
          <span v-else-if="col.key === 'ruleType'">{{ scope.row[col.key] | ruleType }}</span>
          <span v-else-if="col.key === 'opStatus'">
            {{ scope.row[col.key] | opStatus }}{{ scope.row[col.key] ? '，' + scope.row['remark'] : '' }}
          </span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <rule-detail v-model="model" :data="monitorData"></rule-detail>
    <task-detail v-model="taskmodel" :data="consumeData"></task-detail>
  </div>
</template>
<script>
import ruleDetail from './rule-detail'
import taskDetail from './task-detail'
import { isArray } from '@/common/js/utils'
export default {
  name: 'monitorTable',
  components: {
    ruleDetail,
    taskDetail
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  methods: {
    showClick(row) {
      const { ruleDesc } = row
      if (ruleDesc) {
        this.monitorData = [JSON.parse(ruleDesc)].map((ret) => {
          const { monitorConditionDesc } = ret
          const monitor = monitorConditionDesc.split(';')
          if (isArray(monitor) && monitor.length) {
            const [monitorRange, ...monitorConditionInfo] = monitor
            ret.monitorRange = monitorRange
            ret.monitorConditionDesc = monitorConditionInfo
          }
          return ret
        })
        this.model = true
      }
    },
    showConsumeClick(row) {
      const { ruleDesc, ruleId } = row
      if (ruleDesc && ruleId) {
        this.consumeData = [JSON.parse(ruleDesc)].map((ret) => {
          ret.ruleId = ruleId
          ret.consume = [
            {
              mondayVal: ret.mondayVal,
              tuesdayVal: ret.tuesdayVal,
              wednesdayVal: ret.wednesdayVal,
              thursdayVal: ret.thursdayVal,
              fridayVal: ret.fridayVal,
              saturdayVal: ret.saturdayVal,
              sundayVal: ret.sundayVal
            }
          ]
          ret.sumAmountPercent = ret.sumAmountPercent ? (ret.sumAmountPercent * 100).toFixed(2) : 0
          ret.roi = ret.roi ? (ret.roi * 100).toFixed(2) : 0
          return ret
        })
        this.taskmodel = true
      }
    }
  },
  filters: {
    bizType(val) {
      let type = '未知'
      if (val === 1) type = '计划组'
      else if (val === 2) type = '计划'
      else if (val === 3) type = '创意'
      else if (val === 4) type = '账号'
      else if (val === 5) type = '素材'
      return type
    },
    ruleType(val) {
      let type = '未知'
      if (val === 0) type = '手动操作'
      if (val === 1) type = '自动化规则'
      else if (val === 2) type = '新游管控'
      else if (val === 3) type = '一键计划关停'
      else if (val === 4) type = '人员消耗管控'
      else if (val === 5) type = '一键素材关停'
      return type
    },
    opType(val) {
      let type
      switch (val) {
        case 1:
          type = '更改状态'
          break
        case 2:
          type = '更改名称'
          break
        case 3:
          type = '更改预算'
          break
        case 4:
          type = '更改第一阶段出价'
          break
        case 5:
          type = '更改第二阶段出价'
          break
        case 6:
          type = '消息提醒'
          break
        case 7:
          type = '复制计划'
          break
        default:
          type = '未知'
          break
      }
      return type
    },
    opStatus(val) {
      let status = '未知'
      if (val === 1) status = '失败'
      else if (val === 0) status = '成功'
      return status
    }
  },
  data() {
    return {
      model: null,
      taskmodel: null,
      monitorData: [],
      consumeData: []
    }
  }
}
</script>
